import {
    FETCH_WEB_VISITORS_REQUEST,
    FETCH_WEB_VISITORS_SUCCESS,
    FETCH_WEB_VISITORS_FAILURE,
    FETCH_WEB_MINIWIDGET_REQUEST,
    FETCH_WEB_MINIWIDGET_SUCCESS,
    FETCH_WEB_MINIWIDGET_FAILURE,
    FETCH_BETA_SALES_REQUEST,
    FETCH_BETA_SALES_SUCCESS,
    FETCH_BETA_SALES_FAILURE,
    APPLICTION_INSTALATION_REQUEST,
    APPLICTION_INSTALATION_SUCCESS,
    APPLICTION_INSTALATION_FAILURE,
    WEB_WEEKLY_INSIGHT_REQUEST,
    WEB_WEEKLY_INSIGHT_SUCCESS,
    WEB_WEEKLY_INSIGHT_FAILURE,
    ANDROID_USER_ANALYTICS_REQUEST,
    ANDROID_USER_ANALYTICS_SUCCESS,
    ANDROID_USER_ANALYTICS_FAILURE,
    ANDROID_RECENT_ACTIVE_REQUEST,
    ANDROID_RECENT_ACTIVE_SUCCESS,
    ANDROID_RECENT_ACTIVE_FAILURE,
    NEW_BETA_JOINER_REQUEST,
    NEW_BETA_JOINER_SUCCESS,
    NEW_BETA_JOINER_FAILURE
} from "./dashboardAction";

const initialState = {
    data: [],
    loading: false,
    error: null,
};

const webVisitorsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_WEB_VISITORS_REQUEST:
            return { ...state, loading: false, error: null };
        case FETCH_WEB_VISITORS_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case FETCH_WEB_VISITORS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

const webMiniWidgetReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_WEB_MINIWIDGET_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_WEB_MINIWIDGET_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case FETCH_WEB_MINIWIDGET_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

const webBetaSalesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_BETA_SALES_REQUEST:
            return { ...state, loading: false, error: null };
        case FETCH_BETA_SALES_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case FETCH_BETA_SALES_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

const applicationDownloaderReducer = (state = initialState, action) => {
    switch (action.type) {
        case APPLICTION_INSTALATION_REQUEST:
            return { ...state, loading: false, error: null };
        case APPLICTION_INSTALATION_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case APPLICTION_INSTALATION_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

const webWeeklyInsightReducer = (state = initialState, action) => {
    switch (action.type) {
        case WEB_WEEKLY_INSIGHT_REQUEST:
            return { ...state, loading: false, error: null };
        case WEB_WEEKLY_INSIGHT_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case WEB_WEEKLY_INSIGHT_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

const androidUserAnalyticsReducer = (state = initialState, action) => {
    switch (action.type) {
        case ANDROID_USER_ANALYTICS_REQUEST:
            return { ...state, loading: false, error: null };
        case ANDROID_USER_ANALYTICS_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case ANDROID_USER_ANALYTICS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

const androidRecentActiveReducer = (state = initialState, action) => {
    switch (action.type) {
        case ANDROID_RECENT_ACTIVE_REQUEST:
            return { ...state, loading: false, error: null };
        case ANDROID_RECENT_ACTIVE_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case ANDROID_RECENT_ACTIVE_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

const newBetaJoinerReducer = (state = initialState, action) => {
    switch (action.type) {
        case NEW_BETA_JOINER_REQUEST:
            return { ...state, loading: false, error: null };
        case NEW_BETA_JOINER_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case NEW_BETA_JOINER_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export { webVisitorsReducer, webMiniWidgetReducer, webBetaSalesReducer, applicationDownloaderReducer, webWeeklyInsightReducer, androidUserAnalyticsReducer, androidRecentActiveReducer, newBetaJoinerReducer };
